import { render, staticRenderFns } from "./PaymentFormCommonFilters.vue?vue&type=template&id=2868dce6&"
import script from "./PaymentFormCommonFilters.vue?vue&type=script&lang=js&"
export * from "./PaymentFormCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports